export default {
  DELETE_BULK_DOWNLOAD_JOB: 'https://stg-startingpriceapi.financialflows.cimpress.io/v1/job',
  GET_POSSIBILITIES_SET: 'https://stg-startingpriceapi.financialflows.cimpress.io/v1/possibilitiesSet',
  CUSTOM_BULK_EXPORT: 'https://stg-startingpriceapi.financialflows.cimpress.io/v1/jobs/bulkExport',
  BULK_DOWNLOAD_JOBS: 'https://stg-startingpriceapi.financialflows.cimpress.io/v1/jobs',
  DOWNLOAD_SAMPLE_FILE: 'https://stg-startingpriceapi.financialflows.cimpress.io/v1/preferredCombinations/sampleExcel',
  CIMBA_INGEST: 'https://stg-startingpriceapi.financialflows.cimpress.io/v1/ingestToCimba/pricingGrid'
};